import PageMain from '@/components/page-main';
import { useReducer } from 'react';
import useFetch from '@/hooks/useFetch';
import fetchValueReducer from '@/hooks/fetchValueReducer';
import { Table, Alert } from 'antd';

const Index: React.FC = () => {
  const [fetchValue, dispatchFetchValue] = useReducer(fetchValueReducer, { page: 1, size: 10, total: 1 });

  const { data, loading, fetchData } = useFetch("/local/knowledge/prompt", { ...fetchValue }, dispatchFetchValue)

  const contentStyle = { fontSize: "12px", maxHeight: 150, overflowY: 'auto' } as React.CSSProperties;

  return <PageMain>
    <Table
      dataSource={data}
      columns={[
        { title: 'ID', dataIndex: 'id', key: 'id' },
        {
          title: '内容',
          dataIndex: 'content',
          key: 'content',
          render: _ => <Alert
            style={{
              whiteSpace: 'pre-wrap',
            }}
            description={<div style={contentStyle}>{_}</div>}
            type="warning"
          />
        },
        { title: '角色', dataIndex: 'role', key: 'content' },
        { title: '产品名称', dataIndex: 'product', key: 'product' },
        { title: '类型', dataIndex: 'type', key: 'type' },
      ]}
      loading={loading}
      rowKey="id"
      pagination={{
        showSizeChanger: true,
        current: fetchValue.page,
        total: fetchValue.total,
        pageSize: fetchValue.size,
        pageSizeOptions: [10, 20, 50],
        onChange: (page, size) => {
          dispatchFetchValue({ type: 'update', value: { page, size } });
          fetchData();
        },
      }}
    />
  </PageMain>
}

export default Index;